/**
 * 좌표 → 지역 리본 분류 (mimio#30/#33).
 *
 * 전시에 지역 코드를 저장하지 않기로 했기 때문에(#32 "안 만드는 것") 판정은 클라이언트에서 좌표 bbox 로 한다.
 * 행정 경계가 아니라 **근사 사각형**이라 경계에 걸친 소수 장소는 옆 지역으로 갈 수 있다.
 * 칩에 건수를 같이 찍는 이유가 이것 — 한 곳이 잘못 담기면 숫자로 드러난다.
 *
 * 정확한 행정구역이 필요해지는 시점(예: 시·군 단위 필터)에는 백필 때 카카오가 주는
 * road_address_name 의 시도를 컬럼으로 저장하는 쪽으로 바꾼다.
 */

export const REGION_ORDER = ['서울', '경기·인천', '강원', '충청', '호남', '영남', '제주'];

export function resolveRegion(lat, lng) {
  if (lat == null || lng == null) return null;

  // 제주는 본토와 확실히 떨어져 있어 위도만으로 갈린다.
  if (lat < 33.75) return '제주';

  // 서울을 먼저 — 경기 사각형 안에 완전히 들어가 있어 순서가 뒤집히면 서울이 사라진다.
  if (lat >= 37.41 && lat <= 37.72 && lng >= 126.76 && lng <= 127.19) return '서울';

  if (lat >= 37.0 && lng >= 127.75) return '강원';
  if (lat >= 36.9 && lng >= 126.0 && lng <= 127.9) return '경기·인천';
  if (lat >= 35.95 && lng >= 125.9 && lng <= 128.2) return '충청';
  if (lng < 127.55) return '호남';
  return '영남';
}
